var map = {
	"./10-bis-logo.png": "f653",
	"./10-bis.png": "7151",
	"./apple.png": "81f4",
	"./background.png": "9855",
	"./burger-king.png": "1da7",
	"./dominos.png": "3b77",
	"./google.png": "bf83",
	"./house-icon.png": "d36a",
	"./just-eat-logo.png": "2603",
	"./just-eat.png": "7751",
	"./kfc.png": "b877",
	"./lieferando-at.png": "f776",
	"./lieferando-de.png": "83eb",
	"./lieferando-logo.png": "3cbb",
	"./mc-donalds.png": "1a34",
	"./new-york-pizza.png": "2631",
	"./old-wild-west.png": "5a7e",
	"./pizza-hut.png": "14a2",
	"./pizza-lab.png": "77f9",
	"./pyszne-logo.png": "8e26",
	"./pyszne.png": "a972",
	"./quick-burger.png": "3519",
	"./taco-bell.png": "400b",
	"./takeaway-logo.png": "dcbe",
	"./takeaway.png": "3a42",
	"./telepizza.png": "583b",
	"./thuisbezorgd-logo.png": "e480",
	"./thuisbezorgd.png": "e1f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";